/**
 * The visitor's country, from the Worker in front of the app (`/geo`, src/worker.ts): where prices start (the
 * checkout charges by country). Asked once per page load; null when it can't tell (or there's no Worker, locally),
 * and then the server goes by the language.
 */

const COUNTRY = /^[A-Z]{2}$/u;

let asked: Promise<string | null> | null = null;

async function ask(): Promise<string | null> {
  try {
    const res = await fetch("/geo", { cache: "no-store" });
    if (!res.ok) {
      return null;
    }
    const body = (await res.json()) as { country?: unknown };
    return typeof body.country === "string" && COUNTRY.test(body.country) ? body.country : null;
  } catch {
    return null;
  }
}

/** The visitor's country (ISO 3166-1 alpha-2), or null. */
export function visitorCountry(): Promise<string | null> {
  asked ??= ask();
  return asked;
}

/** Forgets the answer (tests). */
export function forgetCountry(): void {
  asked = null;
}
